import {Component, Input} from "@angular/core";
@Component({
    selector: "nv-tab",
    template: `
        <div *ngIf="visible">
            <ng-content></ng-content>
        </div>`
})

export class NvTabComponent {
    @Input() index: number;
    public visible: boolean = false;


    hide(): void { this.visible = false; }
    show(): void { this.visible = true; }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-tabs/nv-tab.component.ts